import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function LoginRedirect() {
  const location = useLocation();
  return <Navigate to={{ pathname: "/login", search: location.search, hash: location.hash }} state={location.state} replace />;
}
